import React from 'react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import ResetPassword from '../../../components/Admin/Settings/ResetPassword/resetPassword';

export default function ResetPasswordPage() {
  return (
    <AdminLayout>
      <ResetPassword />
    </AdminLayout>
  );
}
